import { useEffect, useState } from "react";

/** Returns ``value`` after it has stopped changing for ``delayMs``. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [held, setHeld] = useState(value);
  useEffect(() => {
    const handle = window.setTimeout(() => setHeld(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);
  return held;
}
